// import Video from '@/models/videos/video'

export default {
  UPDATE_IS_UPLOADING: (state, v) => { state.isUploading = v },
  ADD_NEW_UPLOADING_FILE: (state, file) => { state.uploads.unshift(file) },
  ADD_REUPLOADING_FILE: (state, data) => { state.uploads.splice(data.index, 1, data.FILE) },
  CLEAR_UPLOADS: state => { state.uploads = [] },
  DELETE_OBJECT_FROM_LIST: (state, index) => { state.uploads.splice(index, 1) },
}
